import React from "react";

function CustomRadioButton({ label, isSelected, onClick }) {
  return (
    <div
      className={`cp-pc-meet-radio-button d-flex align-items-center m-0 p-0 ${
        isSelected ? "cp-pc-meet-selected" : ""
      }`}
      onClick={onClick}
    >
      <div className="cp-pc-meet-radio-circle"></div>
      {label && <span>{label}</span>}
    </div>
  );
}

export default CustomRadioButton;
